<template>
  <footer class="cat-footer">
    <div class="grid-container">
      <div class="grid-x">
        <div class="small-12 cell">
          <div
            v-if="
              content &&
              content !== '' &&
              !content.startsWith('<!-- no content')
            "
            v-html="content"
          ></div>

          <div v-else class="cat-footer-content">
            <ul>
              <li>
                <span class="copy">&copy; {{ copyYear }} </span>
                <img
                  class="print-only logo-print logo-footer"
                  :src="
                    '/' +
                    appCode +
                    '/resource/app/images/' +
                    resolveTxt('skin.site.logoImgPrint.src', 'logo-bw.png')
                  "
                  :alt="resolveTxt('skin.site.logoImg.alt', 'Verne logo')"
                />
                <img
                  class="print-hidden logo-footer"
                  :src="
                    '/' +
                    appCode +
                    '/resource/app/images/' +
                    resolveTxt('skin.site.logoImg.src', 'logo.svg')
                  "
                  :sizes="
                    resolveTxt(
                      'skin.site.logoImg.sizes',
                      '(max-width: 640px) 120px, (min-width: 640px) 150px'
                    )
                  "
                  :alt="resolveTxt('skin.site.logoImg.alt', 'Verne logo')"
                />

                <span>Powered by Foster Moore - The registry people</span>
                <sup>®</sup>
              </li>
              <li
                v-if="
                  catalyst.catalystVersion && catalyst.catalystVersion.version
                "
                class="verne-version-wrapper"
              >
                <span class="verne-version hidden"
                  >Verne version: {{ catalyst.catalystVersion.version }}</span
                >
              </li>

              <li
                v-if="
                  catalyst.productVersion &&
                  catalyst.productVersion.version &&
                  catalyst.productVersion.version != ''
                "
                class="project-version-wrapper"
              >
                <span class="verne-version hidden"
                  >Product version: {{ catalyst.productVersion.version }}</span
                >
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>

<script lang="ts">
import { defineComponent, inject } from "vue";
import { defaultResolveTxt } from "@/components/field-element";

export default defineComponent({
  setup() {
    // Inject the global value
    const resolveTxt = inject("resolveTxt", defaultResolveTxt);

    return {
      resolveTxt
    };
  },
  name: "CatFooter",
  props: {
    content: {
      type: [String, Object],
      description: "Content of the footer passed as a string or object."
    },
    catalystApi: {
      type: Object,
      default: window["Catalyst"],
      description: "Api passed as an object. Default value 'window[Catalyst]'."
    }
  },
  data: function () {
    const api = this.catalystApi || window["Catalyst"];
    return {
      copyYear: new Date().getFullYear(),
      catalyst: api,
      appCode: api.appCode
    };
  }
});
</script>
